<template>
    <div class="pv4 bg-near-white bb b--light-gray">

        <router-link v-if="linkText !== null" :to="route" class="no-underline">
            <BackLink >{{linkText}}</BackLink>
        </router-link>

        <h4 class="mt1"><slot></slot></h4>

    </div>
</template>

<script>
import BackLink from '@/components/controls/BackLink.vue';

export default {
    components: {
        BackLink
    },
    props: {
        linkText: {
            type: String,
            default: null
        },
        route: {
            type: String
        }
    }
};
</script>
